import styled from "styled-components";
import { Link } from "react-router";


export const NavContainer = styled.nav`
    position: sticky;
    list-style: none;
    font-family: 'Kinkee';
    font-size: 3rem;
    color: purple;
    background-color: #f1a9ca;
    @media (max-width: 767px) {
        font-size: 1.5rem;
    }
    @media (max-width: 1000px) and (min-width: 767px) {
        font-size: 2.5rem;
    }
    
`

export const HoverMenu = styled.div`
    position: absolute;
    background-color: transparent;
    text-align: center;
`
export const SubOption = styled.ul`
    display: none;
    font-size: 2rem;
    text-align: center;
    padding-left: 0;
    list-style: none;
    color: #794b9c !important;
    @media (max-width: 767px) {
        font-size: 1.2rem;
    }
`

export const Linky = styled(Link)`
    text-decoration: none;
    color: purple;
    &:active {
        color: hotpink;
    }
`


export const NavOption = styled.li`
     text-align: center;
    &:hover ${SubOption}{
        display: block;
        list-style: none;
        text-align: left;
    }
`



export const Navigation = styled.ul`
    display: flex;
    justify-content: space-evenly;
    list-style: none;
    
`